import clsx from "clsx";
import { tagsList } from "../../../../constants";
import { labelStyle } from "..";

export default function Tags({ onTags, tags }) {
  return (
    <>
      <label className={labelStyle}>Tags</label>
      <div className={parentContainerStyle}>
        {tagsList.map((tag) => {
          const selected = tags.includes(tag.be);

          return (
            <div
              className={tagStyle + (selected ? " bg-green" : " bg-offWhite")}
              onClick={() => onTags(tag)}
            >
              {tag.display}
            </div>
          );
        })}
      </div>
    </>
  );
}

const parentContainerStyle = clsx(
  "flex flex-wrap items-center justify-between mt-4 mb-20"
);
const tagStyle = clsx("text-sm mb-4 cursor-pointer p-2 w-[110px] mr-4");
